import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/utils/query-keys';
import { BeraStepsService } from '@/components/views/BeraJob/services/api/beraStepsService';

import type { BeraReportV2StepKeyOptions } from '@/types/Bera';

interface GetBeraStepKeyOptionListParams {
	organization_id: string;
	company_id: string;
	step_key_ids: string[];
}

const Service = new BeraStepsService();

export function useGetBeraStepKeyOptionList(params: GetBeraStepKeyOptionListParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_BERA_STEP_KEY_OPTIONS, params],
		queryFn: async () => {
			const requests = params.step_key_ids.map(async (step_key_id) => {
				const request = {
					organization_id: params.organization_id,
					company_id: params.company_id,
					step_key_id
				};

				const [stressLevels, frequencies, totalTaskDurations] = await Promise.all([
					Service.getStressLevels(request),
					Service.getFrequencies(request),
					Service.getTotalTaskDurations(request)
				]);

				const options: BeraReportV2StepKeyOptions = {
					stepKeyId: step_key_id,
					stressLevels,
					frequencies,
					totalTaskDurations
				};

				return options;
			});

			const result = await Promise.all(requests);

			return result;
		},
		enabled: !!params.organization_id && !!params.company_id && !!params.step_key_ids.length
	});
}
